/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Follow_AriaInputs */

const en_directory_footer_follow_aria = /** @type {(inputs: Directory_Footer_Follow_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI elsewhere`)
};

const zh_directory_footer_follow_aria = /** @type {(inputs: Directory_Footer_Follow_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 的其他渠道`)
};

/**
* | output |
* | --- |
* | "Seek AI elsewhere" |
*
* @param {Directory_Footer_Follow_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_follow_aria = /** @type {((inputs?: Directory_Footer_Follow_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Follow_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_follow_aria(inputs)
	return zh_directory_footer_follow_aria(inputs)
});
export { directory_footer_follow_aria as "directory.footer.follow_aria" }